import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { getItemLinkFieldValue } from '@core/jss-utils';
import { InnogyComponentRendering } from '@core/jss-models';
import type { DeviceInfo } from '@innogy/shared/responsive-tools';
import { MediaObserverService } from '@innogy/shared/responsive-tools';
import type { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { backgroundImageFromRendering } from '../../helpers';

@Component({
  selector: 'wl-row-container',
  templateUrl: './row-container.component.html',
  styleUrls: ['./row-container.component.scss'],
})
export class RowContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() backgroundTheme = 'row-container';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() textTheme = '';

  backgroundImageCss = {};

  containerClass$?: Observable<string>;

  constructor(private readonly mediaObserver: MediaObserverService) {}

  ngOnInit() {
    this.renderingToModel(this.rendering);
    this.containerClass$ = this.mediaObserver.deviceInfo$.pipe(
      map(this.mapDeviceInfoToContainer(this.rendering)),
      startWith('container')
    );
  }

  private renderingToModel(rendering: InnogyComponentRendering | undefined) {
    if (rendering == null || rendering.fields == null) {
      return;
    }

    this.backgroundTheme = `${getItemLinkFieldValue(
      rendering.fields,
      'backgroundTheme',
      ''
    )}`;

    this.textTheme = `${getItemLinkFieldValue(
      rendering.fields,
      'textTheme',
      ''
    )}`;

    this.backgroundImageCss = backgroundImageFromRendering(rendering);
  }

  private mapDeviceInfoToContainer(
    rendering: InnogyComponentRendering | undefined
  ) {
    return (info: DeviceInfo) => {
      if (rendering === undefined || rendering.fields === undefined) {
        return 'container';
      }

      const width = getItemLinkFieldValue(rendering.fields, 'width', '');

      if (!width) {
        return 'container';
      }

      switch (width) {
        case 'sm-container-fluid':
          return info.isMobile ? 'container-fluid' : 'container';
        case 'md-container-fluid':
          return info.isMobile || info.isTablet
            ? 'container-fluid'
            : 'container';
        default:
          return width;
      }
    };
  }
}
